import { RemarkContextTypes } from '@app/application/communication/types'
import type { Remark } from '@app/application/communication/types'

export function hasContextOutsideMeeting(remark: Remark): boolean {
  return remark.contextType !== RemarkContextTypes.CLIENT_MEETING
}
